import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalAirportIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_airport"}/>
}
